import * as React from 'react';

import addDays from 'date-fns/addDays';
import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import { Formik } from 'formik';
import { parseDdMmYyyy } from 'v2/formatters/date';
import * as Yup from 'yup';

import { ChangeHistoryFilterForm } from './ChangeHistoryFilterForm';
import { initialChangeHistoryFilter } from '../constants';
import type { ChangeHistoryFilterFormValues, ProductData } from '../constants';

const formValidation = Yup.object().shape({
  dates: Yup.mixed().test('period', 'Período máximo 180 dias', (value: string[]) => {
    const [editedAtDate, editedAtFinalDate] = value;
    if (!editedAtDate || !editedAtFinalDate) return false;
    return !isAfter(
      startOfDay(parseDdMmYyyy(editedAtFinalDate)),
      startOfDay(addDays(parseDdMmYyyy(editedAtDate), 179))
    );
  })
});

type ChangeHistoryFilterProps = {
  setFilters: (filter: ChangeHistoryFilterFormValues) => void;
  productData: ProductData;
};

export const ChangeHistoryFilter = ({ setFilters, productData }: ChangeHistoryFilterProps) => {
  return (
    <div className='mt-5 mb-9'>
      <Formik initialValues={initialChangeHistoryFilter} onSubmit={() => {}} validationSchema={formValidation}>
        {props => <ChangeHistoryFilterForm setFilters={setFilters} productData={productData} {...props} />}
      </Formik>
    </div>
  );
};
